import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../contexts/CartContext";
import { CurrencyContext } from "../../contexts/CurrencyContext";
import { DISPLAY_LANG } from "../../config";
import { errorMessage } from "../../api/global";
import Loading from "./Loading";
import './DomainList.css';

export default function DomainList({ currentDomains, pageData, domainListLoading }) {
  const [cartStatus, setCartStatus] = useState({});
  const { orders, addDomainToCart, cursorLoad } = useContext(CartContext);
  const { selectedCurrency } = useContext(CurrencyContext);
  const navigate = useNavigate();
  const isLogin = localStorage.getItem('token');
  const REDIRECTED_FROM_REGISTER_HOSTING = sessionStorage.getItem('REDIRECTED_FROM_REGISTER_HOSTING');

  const cartDomains = new Set(orders.map(el => el.domain));

  const toggleCart = async (elem) => {
    if (isLogin) {
      try {

        if (REDIRECTED_FROM_REGISTER_HOSTING) {
          const SELECTED_HOSTING_PLAN = JSON.parse(sessionStorage.getItem('SELECTED_HOSTING_PLAN'));
          
          const DATA_FROM_SESSION_STORAGE = {...elem, domain: elem.domain, plan: SELECTED_HOSTING_PLAN.name, billing_type: SELECTED_HOSTING_PLAN.billingType};

          await addDomainToCart(DATA_FROM_SESSION_STORAGE);

          setCartStatus((prev) => ({
            ...prev,
            [elem.id]: !prev[elem.id]
          }));

          sessionStorage.setItem('LAST_REGISTERED_DOMAIN_FOR_HOSTING', JSON.stringify(DATA_FROM_SESSION_STORAGE));
          navigate(REDIRECTED_FROM_REGISTER_HOSTING);

        } else {

          await addDomainToCart(elem);

          setCartStatus((prev) => ({
            ...prev,
            [elem.id]: !prev[elem.id]
          }));

        }




      } catch (error) {
        console.log(error);
        alert(errorMessage[DISPLAY_LANG]);
      }
    } else {
      sessionStorage.setItem('redirectAfterLogin', window.location.pathname);
      navigate('/user/login');
    }
  };

  if (domainListLoading) {
    return <Loading />
  }

  return (
    <div className="domain-list" style={{ cursor: cursorLoad ? 'wait' : '' }}>
      {currentDomains.map((elem, idx) => {
        if (elem.status === 'available') {
          return (
            <div key={idx} className="domain-item flex-between">
              <p className="domain-title">{elem.domain}</p>

              <div className="buy flex-center">
                <span className="price">
                  {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                  {Math.ceil(elem.domain_yearly_price[selectedCurrency.title]).toFixed(2)}
                  {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}
                </span>

                <img
                  src={
                    cartDomains.has(elem.domain)
                      ? "/images/partials/cart-checked.svg"
                      : "/images/partials/cart.svg"
                  }
                  alt={elem.title}
                  onClick={() => toggleCart(elem)}
                  className="btn"
                  style={{ cursor: cursorLoad ? 'wait' : '' }}
                />
              </div>
            </div>
          )
        } else {
          return (
            <div key={idx} className='domain-item registered'>
              <p className="domain-title">
                {elem.domain} ({pageData.registeredDomainMessage[DISPLAY_LANG]})
              </p>
            </div>
          )
        }
      })}
    </div>
  );
}
